module.exports = __webpack_public_path__ + "media/images/illustrations/pre-university-tutoring-eb72a314a10fc90b67a688c23228859a.svg";